<div class="title" fxLayout="row" fxLayoutAlign="start">
  <span mat-dialog-title role="heading" aria-level="1">Invitations</span>
</div>
<mat-dialog-content fxLayoutAlign="center" fxLayout="column">
  <label>You have been invited to join</label>
  <table mat-table matSort [dataSource]="dataSource" class="invitations-table">
    <ng-container matColumnDef="aNo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Case Number"> Case #
      </th>
      <td mat-cell *matCellDef="let userInvitation">
        {{userInvitation.a_No}}
      </td>
    </ng-container>

    <ng-container matColumnDef="protesterCompanyName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Protester">Protester
      </th>
      <td mat-cell *matCellDef="let userInvitation"> {{userInvitation.protesterCompanyName}} </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Do you accept this invitation </th>
      <td mat-cell *matCellDef="let row">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button class="button-cell" mat-raised-button color="primary"
                  (click)="onYes($event, row)">Yes</button>
          <button mat-raised-button color="accent" (click)="onNo($event, row)">No</button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" tabindex="0"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="3">No data"</td>
    </tr>
  </table>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
</mat-dialog-content>
